import { render, staticRenderFns } from "./Vendasmarcas.vue?vue&type=template&id=0f24076c&"
import script from "./Vendasmarcas.vue?vue&type=script&lang=js&"
export * from "./Vendasmarcas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports